import { Partner } from "./types";

export const twPartners: readonly Partner[] = [
  {
    id: "esun",
    link: [
      { label: "(+886)2-2182-1313", href: "tel:+886-02-2182-1313" },
      {
        label: "board",
        href: "https://www.esunbank.com/zh-tw/about/services/customer/message-board",
      },
    ],
    image: "esun.png",
    opTime: "esun_op_time",
    width: 89,
    height: 26,
    seeMoreLink: "https://esun.co/mmJwk",
  },
  {
    id: "ips",
    link: [
      { label: "(+886)2-6631-5190", href: "tel:+886-02-6631-5190" },
      {
        label: "board",
        href: "https://www.i-pass.com.tw/Contact/Index/021e6378-691f-4d4c-b446-5437cbf3dbe8",
      },
    ],
    image: "ips.png",
    opTime: "ips_op_time",
    width: 90,
    height: 35,
    seeMoreLink:
      "https://www.i-pass.com.tw/Faq/Index/3f83761c-ac98-4d60-8db8-53f2d59e188c",
  },
  {
    id: "jko",
    link: [
      { label: "(+886)2-8771-7212", href: "tel:+886-02-8771-7212" },
      { label: "service@jkopay.com", href: "mailto:service@jkopay.com" },
    ],
    image: "jko.png",
    opTime: "jko_op_time",
    width: 90,
    height: 50,
    seeMoreLink: "https://mkt.jkopay.com/event/paypaylogo",
  },
  {
    id: "plp",
    link: [
      { label: "(+886)2-7753-2566", href: "tel:+886-02-7753-2566" },
      { label: "board", href: "https://www.pluspay.com.tw/Forms/Service" },
    ],
    image: "plp.png",
    opTime: "plp_op_time",
    width: 90,
    height: 35,
    seeMoreLink: "https://www.pluspay.com.tw/Faq",
  },
  {
    id: "pxp",
    link: [
      { label: "(+886)2-2278-5200", href: "tel:+886-02-2278-5200" },
      {
        label: "service@pxpayplus.com",
        href: "mailto:service@pxpayplus.com",
      },
    ],
    image: "pxp.png",
    opTime: "pxp_op_time",
    width: 89,
    height: 38,
    seeMoreLink:
      "https://www.pxpayplus.com/FAQ/%E5%A2%83%E5%A4%96%E4%BA%A4%E6%98%93",
  },
  {
    id: "tsb",
    link: [
      { label: "tsb_text_service", href: "https://tsbk.tw/8mzfvs/" },
      { label: "board", href: "https://tsbk.tw/8mzgjg/" },
    ],
    image: "tsb.png",
    opTime: "esun_op_time",
    width: 90,
    height: 27,
    seeMoreLink:
      "https://mkp.taishinbank.com.tw/TsCms/WebMarketing?id=WM_20260102115536649",
  },
];
